/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { apiClient } from "./ApiClient";

/** The server's answer about a Download Link (back end: product/download_check.py). */
export interface DownloadCheckAnswer {
  available?: boolean;
  /** Only present when available is false; empty when no alternate is set. */
  alternate?: string;
}

/**
 * Session 507 review, VM-1: the server's check of a Download Link, made when
 * the download dialog opens.
 *
 * Never cached and never retried -- "Try again" must really check again -- and
 * given 4 seconds, because the customer is waiting for a download. The server
 * answers inside that: its whole check is bounded at 3 seconds
 * (download_check.py, DOWNLOAD_CHECK_DEADLINE). Running out of time and a 429
 * (the visitor's hourly allowance is used up) are expected, not errors to
 * investigate: the download simply goes ahead, and neither reaches Sentry
 * (quietTimeout, quietStatuses; N-8).
 *
 * Its own module, depending on the client alone, so the shared download hook
 * does not pull the sign-in client and the i18n set-up in with endpoints.ts.
 */
export function checkDownloadLink(url: string): Promise<DownloadCheckAnswer> {
  return apiClient.get<DownloadCheckAnswer>(
    `download-check/?url=${encodeURIComponent(url)}`,
    {
      cache: false,
      retry: false,
      timeout: 4000,
      quietStatuses: [429],
      quietTimeout: true,
    },
  );
}
